export interface NicknameValidationData {
    IsNicknameValid: boolean;
}
